import React from 'react'
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faAppStoreIos } from '@fortawesome/free-brands-svg-icons';
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (

        <section className="footer-section" style={{backgroundImage: `url("/img/footer.svg")`}}>
            <div className="footer-overlay" style={{backgroundImage: `url("/img/f-overlay.webp")`}}>
            </div>
                <div className="footer-content">
                    <div className="container">
                        <div className="footer-main">
                            <div className="social">
                                <h4 className="heading">Social</h4>
                                <div className="link">
                                    <a href="https://www.instagram.com/elite.partyz/" className="link-tiem"><FontAwesomeIcon icon={faInstagram} /></a>
                                    <a href="https://www.facebook.com/elitepartyz.io/" className="link-tiem"><FontAwesomeIcon icon={faFacebook} /></a>
                                    <a href="https://twitter.com/ElitePartyz" className="link-tiem"><FontAwesomeIcon icon={faTwitter} /></a>

                                </div>
                            </div>
                            <div className="download">
                                <h4 className="heading">DOWNLOAD THE APP FROM</h4>
                                <div className="link">
                                    <a href="https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1" className="link-tiem"><FontAwesomeIcon icon={faAppStoreIos} /></a>
                                    <a href="https://play.google.com/store/apps/details?id=com.app.partyzsupplier" className="link-tiem"><FontAwesomeIcon icon={faGooglePlay} /></a>
                                </div>
                            </div>
                            <div className="contact">
                                <a href="tel:1300 757 018" className="phone"> Phone 1300 757 018</a>
                            </div>
                            <div className="footer-copyright">
                                <p className="copyright">
                                <a href="https://elitepartyz.com/privacy-policy">Privacy Policy</a> | <a href="https://elitepartyz.com/terms-and-conditions"> Terms & Conditions</a> </p>
                                <p className="copyright">©2023 Elite Partyz. All Rights Reserved</p>
                            </div>
                        </div>
                    </div>

            </div>
        </section>
    )
}

export default Footer
